import './OrgIndicatorsPerSDG.css';

import React, { useState } from 'react';
import usePlansData from '../../../../b2b-plans/hooks/usePlansData';
import { Box } from '@mui/material';
import PlansAreaIndicatorsImpact from '../../../../b2b-frameworks/components/framework-impact/PlansAreaIndicatorsImpact';
import B2BElementsExplorerInMemory from '../../../../b2b-common/B2BElementsExplorerInMemory';
import AreaIndicatorMiniCard from '../../../../b2b-plans/components/area-indicators/AreaIndicatorMiniCard';

const OrgIndicatorsPerSDG = ({ widget }) => { 
    const { organizationPlansData, isSearching } = usePlansData(50);
    const plansUUIDs = (organizationPlansData?.content || []).map(plan => plan.plan.planUUID);
    const [areaIndicators, setAreaIndicators] = useState(null);

    if ((!organizationPlansData) || isSearching) {
        return null;
    }

    const handleSelectedLevelNUpdate = (areaIndicators) => {
        // console.log('Selected LevelN:', areaIndicators);
        setAreaIndicators(areaIndicators);               
    };

    return (
        <Box className={'OrgIndicatorsPerSDG-container'}>
            <PlansAreaIndicatorsImpact frameworkSuite='generic' frameworkId={2} plansUUIDs={plansUUIDs}
                showStatus={true} showTrend={true} showProgress={true}
                onSelectedLevelN={handleSelectedLevelNUpdate}
            />
            {areaIndicators && (
                <B2BElementsExplorerInMemory
                    elementsData={{ content: areaIndicators }}
                    className={'OrgIndicatorsPerSDG-elementsExplorer'}
                    ElementComponent={AreaIndicatorMiniCard}
                    elementComponentPropName={'areaIndicator'}
                    otherComponentProps={{
                        showIndicatorWeight: false,
                        showCalendarProgress: false,
                    }}
                    numRows={4}
                />
            )}
        </Box>
    );

};

export default OrgIndicatorsPerSDG;